<template>
  <div
    id="multipleAttendance"
    class="modal fade"
    tabindex="-1"
    role="dialog"
    aria-labelledby="multipleAttendanceLabel"
    aria-hidden="true"
    data-backdrop="static"
    data-keyboard="false"
  >
    <div
      class="modal-dialog"
      role="document"
    >
      <form
        class="modal-content"
        @submit.prevent="confirmUpdateMultipleCrewAttendance"
      >
        <div class="modal-header row mr-0 ml-0">
          <div class="col col-sm-8">
            <h6
              class="modal-title font-weight-bolder"
              id="multipleAttendanceLabel"
            >
              Update Multiple {{ timeIn ? 'Time In': 'Time Out' }}
            </h6>
          </div>
          <div class="col col-sm-4">
            <button
              data-dismiss="modal"
              aria-label="Close"
              class="btn btn-sm btn-xs btn-outline-secondary font-weight-bolder float-right"
              @click="selectedAttendances = []"
            >
              Cancel
            </button>

            <button
              type="submit"
              class="btn btn-sm btn-xs btn-outline-primary font-weight-bolder float-right mr-2"
            >
              Save
            </button>
          </div>
        </div>

        <div class="modal-body">
          <div class="card">
            <div class="card-header p-0">
              <div
                class="form-group form-row mb-0"
                title="Click here to check all crew"
              >
                <div class="col col-sm-1 pt-1">
                  <input
                    type="checkbox"
                    name="status"
                    id="allCrew"
                    class="form-control form-control-xs"
                    @click="selectAll"
                    :checked="selectedAll"
                  >
                </div>
                <label
                  for="allCrew"
                  class="col col-sm-11 col-form-label font-weight-bolder text-left"
                >Select Crew</label>
              </div>
            </div>
            <div class="card-body">
              <div
                class="form-group form-row"
                v-for="crew in scheduledCrews"
                :key="crew.crew_training_schedule_id"
              >
                <div class="col col-sm-1 pt-1">
                  <input
                    type="checkbox"
                    class="form-control form-control-xs"
                    :id="'crew' + crew.crew_training_schedule_id"
                    :value="crew.crew_training_schedule_id"
                    v-model="selectedAttendances"
                    :disabled="hasTime(crew)"
                  >
                </div>
                <label
                  class="col-sm-8 col-form-label"
                  :for="'crew' + crew.crew_training_schedule_id"
                >
                  {{ crew.name }}
                </label>
              </div>


              <div class="form-group form-row">
                <label class="col col-sm-3 col-form-label font-weight-bolder text-right">TIME {{ (timeIn) ?'IN' :'OUT' }}:</label>
                <div class="col col-sm-5">
                  <input
                    type="time"
                    name="time"
                    id="time"
                    required
                    class="form-control form-control-xs"
                    v-model="time"
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>

    import { mapGetters, mapActions } from 'vuex';
    import { formMixins } from '../../../../mixins/formMixins';

    export default {
        mixins:[ formMixins ],
        name: "UpdateMultipleAttendance",
        data() {
            return {
                selectedAttendances: [],
                time: this.getCurrentTime(),
            }
        },
        methods: {
            ...mapActions([ 'updateMultipleCrewAttendance' ]),
            async confirmUpdateMultipleCrewAttendance() {
                if(await this.confirmUpdateAlert('Are you sure you Want to Update Attendance Time of the following crews?')) {
                    let params = {
                        crewTrainingScheduleIds: this.selectedAttendances,
                        training_schedule_session_id: this.trainingSchedule.training_schedule_sessions[this.sessionIndex - 1].id,
                        time: this.time,
                        timeIn: this.timeIn,
                    };
                    if(this.updateMultipleCrewAttendance(params)) {
                        this.successAlert('Crew Attendance Successfully Updated', 'UPDATE');
                        this.selectedAttendances = [];
                        this.time = this.getCurrentTime();
                    } else {
                        this.errorAlert(null, 'UPDATE ATTENDANCE TIME');
                    }
                }
            },

            selectAll(e) {
                if(e.target.checked) {
                    let time = this.timeIn ? 'time_in': 'time_out';
                    let crewWithAttendance = this.trainingSession.crew_attendances
                        .filter(attendance => {
                            return attendance[time] !== null;
                        }).map(attendance => {
                            return attendance.crew_training_schedule_id
                        });
                    this.scheduledCrews
                        .filter(crew => {
                            return !crewWithAttendance.includes(crew.crew_training_schedule_id);
                        }).forEach(crew => {
                        if(!this.selectedAttendances.includes(crew.crew_training_schedule_id)) {
                            this.selectedAttendances.push(crew.crew_training_schedule_id);
                        }
                    });
                } else {
                    this.selectedAttendances = [];
                }
            },

            hasTime(crew) {
                let time = this.timeIn ? 'time_in': 'time_out';
                return this.trainingSession.crew_attendances.map((attendance) => {
                    return {
                        crewId: attendance.crew_training_schedule_id,
                        [time]: attendance[time],
                    };
                }).filter(attendance => {
                    return crew.crew_training_schedule_id === attendance.crewId && attendance[time] !== null;
                }).length > 0;
            }

        },

        computed: {
            ...mapGetters([ 'scheduledCrews', 'trainingSession', 'timeIn', 'sessionIndex', 'trainingSchedule' ]),
            selectedAll() {
                let selectAll = true;
                let time = this.timeIn ? 'time_in': 'time_out';

                let crewWithAttendance = this.trainingSession.crew_attendances
                    .filter(attendance => {
                        return attendance[time] !== null;
                    }).map(attendance => {
                        return attendance.crew_training.crew_training_schedule_id
                    });

                this.scheduledCrews.filter(crew => {
                    return !crewWithAttendance.includes(crew.crew_training_schedule_id);
                }).forEach(crew => {
                    if(!this.selectedAttendances.includes(crew.crew_training_schedule_id)) selectAll = false;
                });
                return selectAll;
            },
        }
    }
</script>

<style scoped>

</style>
